import { render, staticRenderFns } from "./wxMenus.vue?vue&type=template&id=848bc4ec&scoped=true"
import script from "./wxMenus.vue?vue&type=script&lang=js"
export * from "./wxMenus.vue?vue&type=script&lang=js"
import style0 from "./wxMenus.vue?vue&type=style&index=0&id=848bc4ec&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848bc4ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/crmeb/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('848bc4ec')) {
      api.createRecord('848bc4ec', component.options)
    } else {
      api.reload('848bc4ec', component.options)
    }
    module.hot.accept("./wxMenus.vue?vue&type=template&id=848bc4ec&scoped=true", function () {
      api.rerender('848bc4ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appSetting/wxAccount/wxMenus.vue"
export default component.exports